import DiscordLogin from './DiscordLogin';
export default DiscordLogin;
